import { render, staticRenderFns } from "./ListLendersAll.vue?vue&type=template&id=485d296a&scoped=true&"
import script from "./ListLendersAll.vue?vue&type=script&lang=js&"
export * from "./ListLendersAll.vue?vue&type=script&lang=js&"
import style0 from "./ListLendersAll.vue?vue&type=style&index=0&id=485d296a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d296a",
  null
  
)

export default component.exports